export interface IEmailModelTemplateVariablesResponse {
    data: {
        success: boolean;
        message: string;
        results: string[]
    }
}